// #region Imports
import { defineComponent, nextTick } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-sticky-bar',
    // #endregion        
    // #region Data
    props: {
        barObject: {
            type: Object,
            required: false,
            default: {
                items: []
            },
        },
    },
    data: () => ({
        activeItem: null,
    }),
    // #endregion
    // #region Constructor
    mounted() {
        this.updateBody();
    },
    unmounted() {
        this.removeBody();
    },
    // #endregion
    // #region Watch
    watch: {
        'barObject': function (value) {
            this.updateBody();
        },
    },
    // #endregion
    // #region Methodes
    methods: {
        // #region Core
        updateBody() {
            nextTick(() => {
                let tElement = this.$refs.elStickyBar;
                if ((this.barObject?.items?.length ?? 0) > 0) {
                    if (tElement) {
                        tElement.classList.add("loaded");
                    }
                    document.body.classList.add("g-stick-bar__active");
                }
                else {
                    if (tElement) {
                        tElement.classList.remove("loaded");
                    }
                    document.body.classList.remove("g-stick-bar__active");
                }
            });
        },
        removeBody() {
            nextTick(() => {
                document.body.classList.remove("g-stick-bar__active");
            });
        },
        // #endregion
        // #region Event-Callbacks
        onDeactivate() {
            this.activeItem = null;
        },
        onActivate(item, e) {
            if (this.$host.pageMeta.width >= 970) {
                this.activeItem = null;
                return;
            }
            if (this.activeItem === item) {
                //Do nothing
            }
            else {
                if (e) {
                    e.preventDefault();
                }
                this.activeItem = item;
            }
        }
        // #endregion
    },
    // #endregion
});
// #endregion
